import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import RoleSearch from "./RoleSearch";
import RoleTable from "./RoleTable";
import '../modal.scss';
import RoleCreate from "./RoleCreate";
import RolePermissions from "./RolePermissions";
import AddPermissions from "./AddPermissions";
import {Slide, toast} from "react-toastify";

function Roles({loggedInUser}) {
    const [roles, setRoles] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingRole, setEditingRole] = useState(null);

    const [showPermissionsModal, setShowPermissionsModal] = useState(false);
    const [viewingRole, setViewingRole] = useState(null);

    const [showAddPermissionModal, setShowAddPermissionModal] = useState(false);
    const [addingPermissionRole, setAddingPermissionRole] = useState(null);

    const baseUrl = `/tenants/${loggedInUser.TenantId}/roles`;

    const fetchRoles = async (params) => {
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setRoles(response.data.list);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    useEffect(() => {
        fetchRoles();
    }, []);

    const search = async (name) => {
        const newSearchParams = {name};
        await fetchRoles(newSearchParams);
    };

    const handleCreate = () => {
        setEditingRole(null);
        setShowModal(true);
    };

    const handleEdit = (role) => {
        setEditingRole(role);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `${baseUrl}/${id}`;

        try {
            await apiClient.delete(url);
            await fetchRoles();
        } catch (error) {
            console.error('Error deleting role:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (roleData) => {
        const url = editingRole ? `${baseUrl}/${editingRole.id}` : baseUrl;

        try {
            if (editingRole) {
                await apiClient.patch(url, roleData);
                toast.success('Language updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, roleData);
                toast.success('Language created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchRoles();
        } catch (error) {
            console.error('Error saving role:', error);
        }
    };

    const handleViewPermissions = (role) => {
        setViewingRole(role);
        setShowPermissionsModal(true);
    };

    const handleClosePermissionsModal = () => {
        setShowPermissionsModal(false);
    };

    const handleAddPermission = (role) => {
        setAddingPermissionRole(role);
        setShowAddPermissionModal(true);
    };

    const handleCloseAddPermissionModal = () => {
        setShowAddPermissionModal(false);
    };

    const handleSubmitAddPermission = async (newPermissions) => {
        const url = `/tenants/${loggedInUser.TenantId}/roles/${addingPermissionRole.id}/permissions`;

        try {
            await apiClient.patch(url, {newPermissions});
            setShowAddPermissionModal(false);
            await fetchRoles();
        } catch (error) {
            console.error('Error adding permissions:', error);
        }
    };

    return (
        <div className="mainBody">
            <RoleSearch onSearch={search} onCreate={handleCreate}/>
            <RoleTable roles={roles} onEdit={handleEdit} onDelete={handleDelete}
                       onViewPermissions={handleViewPermissions} onAddPermission={handleAddPermission}/>
            {showModal && <RoleCreate role={editingRole} onClose={handleCloseModal} onSubmit={handleSubmitModal}/>}
            {showPermissionsModal &&
                <RolePermissions loggedInUser={loggedInUser} role={viewingRole} onClose={handleClosePermissionsModal}/>}
            {showAddPermissionModal && <AddPermissions loggedInUser={loggedInUser} role={addingPermissionRole}
                                                       onClose={handleCloseAddPermissionModal}
                                                       onSubmit={handleSubmitAddPermission}/>}
        </div>
    );
}

export default Roles;
